import { useState } from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import {
  btnSize,
  btnType,
  Button,
  colors,
  fontWeight,
  Input,
  inputSize,
  Text,
  textLevel,
} from '../../../../packages';
import { Drawer, drawerPosition, drawerType } from '../../../../packages/ui/organisms/drawer';
import { useStyles } from '../ClaimDetail.styles';
import { Typography } from '@mui/material';

const defaultData = {
  claimStatus: '',
  datePaid: '',
  amountPaid: 0,
  amountDenied: 0,
  notes: '',
  trackingNumber: '',
  initialBillingDate: '',
};

const labels = {
  claimStatus: 'Claim Status',
  amountPaid: 'Amount Paid',
  datePaid: 'Date Paid',
  amountDenied: 'Amount Denied',
  notes: 'Notes',
  trackingNumber: 'Tracking Number',
  initialBillingDate: 'Initial Billing Date',
};

export const ClaimNoteDrawer = ({ data, open, onClose, onSubmit }) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({ ...data });
  const [errors, setErrors] = useState(defaultData);

  const onChangeField = field => e => {
    if (errors[field]) {
      setErrors(s => ({ ...s, [field]: '' }));
    }
    setFormData(old => ({
      ...old,
      [field]: e.target?.value,
    }));
  };

  const onChangeStatus = () => {
    const { notes } = formData;
    onSubmit({ notes }, 'statusDetail');
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      variant={drawerType.FORM}
      position={drawerPosition.RIGHT}
      title="Edit Note"
      submitBtnTitle="Update"
      onSubmit={onChangeStatus}
    >
      <Box className={classes.inputWrapper}>
        <label htmlFor="notes">
          <Text level={textLevel.S} weight={fontWeight.BOLD}>
            {labels.notes}
          </Text>
        </label>
        <Input
          name="notes"
          value={formData.notes || ''}
          onChange={onChangeField('notes')}
          size={inputSize.M}
          placeholder="Enter your notes"
        />
      </Box>
    </Drawer>
  );
};

const ClaimNote = ({ onSubmit, data = defaultData }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        background: colors.white,
        boxShadow:
          '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
        borderRadius: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" pl={3} py="12px" pr={2}>
        <Typography sx={{ fontSize: '18px', fontWeight: 600, lineHeight: '24px' }}>Claim Notes</Typography>
        <Button
          className={classes.btn}
          variant={btnType.TEXT}
          onClick={() => setOpen(true)}
          size={btnSize.SMALL}
        >
          Edit note
        </Button>
      </Box>
      <Divider />

      <Box display="flex" p={4} flexWrap="wrap" gap={3} rowGap={4}>
        <Box display="flex" flexDirection="column" minWidth="160px">
          <Text className={classes.colLabel} level={textLevel.S} weight={fontWeight.SEMI_BOLD}>
            Notes
          </Text>
          <Text className={classes.marginTop8} level={textLevel.M} weight={fontWeight.MEDIUM}>
            {data?.notes || 'No notes available'}
          </Text>
        </Box>
      </Box>
      {open && <ClaimNoteDrawer data={data} open={open} onClose={() => setOpen(false)} onSubmit={onSubmit} />}
    </Box>
  );
};

export default ClaimNote;
